import React, { useState } from "react";

const ReviewTable = ({ myallreview }) => {
  //   console.log(myallreview);
  const [myRemainingReview, setMyRemainingReview] = useState([]);
  const { writenReview, serviceName, servicePhoto, _id } = myallreview;
  const handleDelete = (_id) => {
    const proceed = window.confirm("are you sure to delete the review?");
    if (proceed) {
      fetch(`https://spooky-journalist-server.vercel.app/myreviews/${_id}`, {
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(myRemainingReview),

      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.deletedCount > 0) {
            alert("deleted Successfully");
            const remainingReviews = myallreview.filter(
              (reviews) => reviews._id !== _id
            );
            setMyRemainingReview(remainingReviews);
          }
        });
    }
  };
  return (
    <tr className="border border-2 p-10">
      <th>
        <button
          onClick={() => handleDelete(_id)}
          className="btn btn-ghost text-red-600"
        >
          Delete
        </button>
      </th>
      <td className="border border-2 p-10">
        <div className="flex items-center space-x-3">
          <div className="avatar">
            <div className="mask mask-squircle w-12 h-12">
              <img src={servicePhoto} alt="Avatar Tailwind CSS Component" />
            </div>
          </div>
          <div>
            <div className="font-bold">{serviceName}</div>
          </div>
        </div>
      </td>
      <td className="w-[300px] break-words">{writenReview}</td>
      <th className="border border-2 p-10">
        <button className="btn btn-ghost">Update</button>
      </th>
    </tr>
  );
};

export default ReviewTable;
